module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel202309_06_1280_1280_en-7130fc7e24a3e8735c2f331aefaa0b89.jpg";